import { render, staticRenderFns } from "./VueDataTableIcon.vue?vue&type=template&id=206b334a&scoped=true"
import script from "./VueDataTableIcon.vue?vue&type=script&lang=js"
export * from "./VueDataTableIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b334a",
  null
  
)

export default component.exports